import { render, staticRenderFns } from "./ChainsJsonTable.vue?vue&type=template&id=6518f1e9&scoped=true"
import script from "./ChainsJsonTable.vue?vue&type=script&lang=js"
export * from "./ChainsJsonTable.vue?vue&type=script&lang=js"
import style0 from "./ChainsJsonTable.vue?vue&type=style&index=0&id=6518f1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518f1e9",
  null
  
)

export default component.exports